module.exports = __webpack_public_path__ + "static/media/empty.900e5819.svg";